// extracted by mini-css-extract-plugin
export var statItem = "_hv-1";
export var statsRow = "_hv-0";